/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingMetricAccessFilters {
    getFixupPrototypeFunction() { return BillingMetricAccessFilters.fixupPrototype; }

    static newInstance(model: Partial<BillingMetricAccessFilters>): BillingMetricAccessFilters {
        let obj = Object.assign(new BillingMetricAccessFilters(), model);
        BillingMetricAccessFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingMetricAccessFilters>): BillingMetricAccessFilters {
        if (!model) return null;
        return BillingMetricAccessFilters.newInstance(<BillingMetricAccessFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingMetricAccessFilters) {
        if (!obj) return;

        models.BillingMetricAccessFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingMetricAccessFilters): boolean {
        Object.setPrototypeOf(obj, BillingMetricAccessFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.native_detail_type) {
            models.ServiceAccountNativeDetailsBaseForCloud.fixupPrototype(this.native_detail_type);
        }
    }

    /**
     * The Sys ID of the metric
     */
    metric_sys_id: string;

    /**
     * Cloud account native details type
     */
    native_detail_type: models.ServiceAccountNativeDetailsBaseForCloud;

}
